import { render, staticRenderFns } from "./AirtableImage.vue?vue&type=template&id=00833f48&"
import script from "./AirtableImage.vue?vue&type=script&lang=js&"
export * from "./AirtableImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports